module.exports = () => (new Date()).getTime();
